import { MarkerClusterer } from "@googlemaps/markerclusterer";

import '../sass/school-map.scss';

(() => {
    const googleMapsScript = document.querySelector('#blenheim-schools-google-maps');
    const markerclustererScript = document.querySelector('#blenheim-schools-markerclusterer');
    const swiperScript = document.querySelector('#blenheim-schools-swiper-js');
    const $blocks = document.querySelectorAll('.block.school-map');

    let map, schools, mapMarkers = [], markerCluster = null;

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $map = $block.querySelector('.school-map__map');
        const $filter = $block.querySelector('.school-map__filter');
        const $filterAge = $filter?.querySelector('[name="age"]');
        const $filterLocation = $filter?.querySelector('[name="location"]');
        const $countLabel = $block.querySelector('.school-map__count');
        const $resetBtn = $block.querySelector('.school-map__reset-btn');

        const filterLocations = () => {
            $blocks.forEach($block => {
                const $map = $block.querySelector('.school-map__map');

                $map.dispatchEvent(new CustomEvent('filter-update', {
                    detail: {
                        age: $filterAge?.value ? Number($filterAge?.value) : null,
                        location: $filterLocation?.value ? $filterLocation?.value : null,
                    }
                }));
            });
        };

        const resizeMap = async (filter = null) => {
            const { LatLngBounds, LatLng } = await google.maps;

            const bounds = new LatLngBounds();

            mapMarkers?.forEach(mapMarker => {
                const lat = mapMarker?.position?.lat();
                const lng = mapMarker?.position?.lng();

                const position = new LatLng(lat, lng);

                bounds.extend(position);
            });

            // Don't zoom in too far on only one marker
            if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
            var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.02, bounds.getNorthEast().lng() + 0.02);
            var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.02, bounds.getNorthEast().lng() - 0.02);
            bounds.extend(extendPoint1);
            bounds.extend(extendPoint2);
            } 

            map.fitBounds(bounds);
        };

        const updateCountLabel = count => {
            if (!$countLabel) return;

            let labelText = $countLabel.dataset.labelMultiple;

            if (count === 1) {
                labelText = $countLabel.dataset.labelSingle;
            }

            $countLabel.innerHTML = labelText.replace('{count}', count);
        }

        const initMarkers = async(filter = null) => {
            const { MarkerClusterer, GridAlgorithm } = await markerClusterer;
            const { InfoWindow, LatLng, Marker, Size } = await google.maps;

            const infoWindow = new InfoWindow({
                content: '',
                maxWidth: 375,
                disableAutoPan: false,
            });

            const iconSvg = window.btoa(`
                <svg fill="#243359" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
                    <circle cx="18" cy="18" r="18" />    
                </svg>`);

            const iconSvgHover = window.btoa(`
                <svg fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
                    <circle cx="18" cy="18" r="18" />    
                </svg>`);

            mapMarkers?.forEach(marker => {
                marker.setMap(null);
            });

            if (markerCluster) {
                markerCluster.setMap(null);
            }

            mapMarkers = schools?.filter(school => {
                if (!filter?.age && !filter?.location) return true;

                return (!filter?.age || (filter?.age >= school?.ages?.[0] && filter?.age <= school?.ages?.[1])) && 
                    (!filter?.location || school?.locations?.includes(filter?.location));
            })?.map(school => {
                const position = new LatLng(school?.location?.lat, school?.location?.lng);

                const marker = new Marker({
                    position,
                    icon: {
                        url: `data:image/svg+xml;base64,${iconSvg}`,
                        scaledSize: new Size(36, 36),
                    },
                    label: {
                        text: '1',
                        color: '#F6E6DE',
                        fontSize: '16px',
                    }
                });

                const closeMarker = marker => {
                    marker.setIcon({
                        url: `data:image/svg+xml;base64,${iconSvg}`,
                        scaledSize: new Size(36, 36),
                    });

                    marker.label = {
                        text: '1',
                        color: '#F6E6DE',
                        fontSize: '16px',
                    };
                }

                marker.addListener('click', () => {
                    mapMarkers.forEach(marker => {
                        closeMarker(marker);
                    });

                    if (infoWindow.isOpen) {
                        infoWindow.close();

                        if (infoWindow.position.lat() === marker.position.lat() && infoWindow.position.lng() === marker.position.lng()) {
                            return;
                        }
                    }

                    infoWindow.setContent(school?.cardHtml);

                    infoWindow.open({
                        anchor: marker,
                        map: map
                    });

                    window.requestAnimationFrame(() => {
                        const $cardCarousel = $map.querySelector('.school-map-card__carousel');
                        const $cardCarouselNavigationPrev = $map.querySelector('.school-map-card__carousel-navigation-prev');
                        const $cardCarouselNavigationNext = $map.querySelector('.school-map-card__carousel-navigation-next');

                        if ($cardCarousel) {
                            new Swiper($cardCarousel, {
                                loop: true,
                                navigation: {
                                    nextEl: $cardCarouselNavigationNext,
                                    prevEl: $cardCarouselNavigationPrev,
                                },
                            });
                        }
                    });

                    infoWindow.addListener('closeclick', () => {
                        marker.setIcon({
                            url: `data:image/svg+xml;base64,${iconSvg}`,
                            scaledSize: new Size(36, 36),
                        });

                        marker.label = {
                            text: '1',
                            color: '#F6E6DE',
                            fontSize: '16px',
                        };
                    });

                    closeMarker(marker);
                });

                return marker;
            });

            updateCountLabel(mapMarkers?.length);

            if (mapMarkers?.length) {
                markerCluster = new MarkerClusterer({
                    markers: mapMarkers, 
                    map: map,
                    onClusterClick: (e, cluster) => {
                        infoWindow.close();
                        map.fitBounds(cluster.bounds);

                        return true;
                    },
                    algorithm: new GridAlgorithm({ 
                        maxDistance: 40000,
                        gridSize: 36
                    }),
                    renderer: {
                        render: function ({ count, position }, stats) {
                            const svg = window.btoa(`
                                <svg fill="#243359" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
                                    <circle cx="18" cy="18" r="18" />    
                                </svg>`);
                                
                            return new Marker({
                                position,
                                icon: {
                                    url: `data:image/svg+xml;base64,${svg}`,
                                    scaledSize: new Size(36, 36),
                                },
                                label: {
                                    text: String(count),
                                    color: '#F6E6DE',
                                    fontSize: '16px',
                                    fontFamily: "'ProdigySans', sans-serif",
                                },
                                zIndex: Number(Marker.MAX_ZINDEX) + count,
                            });
                        }
                    }
                });
            }

            resizeMap(filter);
        };

        const filterMapLocations = e => {
            initMarkers(e.detail);
        };

        const initMap = async () => {
            const { Map, InfoWindow, OverlayView } = await google.maps;

            if (!$map) return;

            schools = $map?.dataset?.schools ? JSON.parse($map?.dataset?.schools) : [];

            map = new Map($map, {
                center: { lat: 51.5, lng: -0.1 },
                zoom: 10,
                clickableIcons: false,
                disableDefaultUI: true,
                cameraControl: true,
            });

            $map.addEventListener('filter-update', filterMapLocations);

            initMarkers();
        };

        const initFilter = async () => {
            if ($filterAge) {
                $filterAge.addEventListener('change', filterLocations);
            }

            if ($filterLocation) {
                $filterLocation.addEventListener('change', filterLocations);
            }

            if ($resetBtn) {
                $resetBtn.addEventListener('click', () => {
                    $filterAge.value = '';
                    $filterLocation.value = '';

                    filterLocations();
                });
            }
        };

        if (typeof Swiper !== 'undefined') {
            initMap();
            initFilter();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initMap();
                initFilter();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#blenheim-schools-swiper-js');

                if (!swiperScript) return;

                initMap();
                initFilter();
            });
        }
    });
})();
